export default __webpack_public_path__ + "static/ReviewStar-46a999c27753a0d0b0a4e9674ca10857.png";